import type React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useMentionInputNotice } from "@/hooks/useMentionInputNotice";

interface PostCardEditFormProps {
  value: string;
  originalContent: string;
  isSubmitting: boolean;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

export const PostCardEditForm: React.FC<PostCardEditFormProps> = ({
  value,
  originalContent,
  isSubmitting,
  onChange,
  onKeyDown,
  onCancel,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const hasTypedMentionInEdit = useMentionInputNotice(
    value,
    originalContent,
    originalContent,
  );

  return (
    <div className="space-y-2">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        className="w-full resize-none rounded-md border border-gray-300 p-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Edit your post..."
        disabled={isSubmitting}
        rows={15}
      />
      {hasTypedMentionInEdit && (
        <div className="rounded border border-amber-200 bg-amber-50 p-2 text-sm text-amber-700">
          {t("common.editMentionNoNotificationWarning")}
        </div>
      )}
      <div className="flex justify-end gap-2">
        <Button onClick={onCancel} disabled={isSubmitting} variant="ghost">
          {t("common.cancel")}
        </Button>
        <Button
          onClick={() => void onSubmit()}
          disabled={isSubmitting || value.trim() === originalContent.trim()}
          variant="teal"
        >
          {t("common.save")}
        </Button>
      </div>
    </div>
  );
};
